// extracted by mini-css-extract-plugin
export default {"loader_page":"loader_page___ePNIf","loader":"loader___O3LFC"};